var giphy_viewer_default = {
  "giphyWrapper": "sWQI-",
  "giphy_player": "gG0Ow",
  "playIcon": "MsGvy",
  "gifRatio": "eRgbd"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
